<div class="index-head" fxLayout="row" fxLayoutAlign="space-between center">
    <span>
        Lead Data
    </span>

    <button [attr.guide]="'lead-dynamic-form-btn-1-1' + '__' + sanitizeUrl(url)" mat-dialog-close mat-icon-button>
        <mat-icon>
            close
        </mat-icon>
    </button>
</div>
<div *ngIf="formInit">
    <form class="padding-10" [formGroup]="form" autocomplete="off">
        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Contact Type</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-contacttype-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="ContactType"/>
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Contact ID</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-contactid-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="ContactID"/>
            </mat-form-field>

            <mat-radio-group [formControl]="floatLabelControl" fxLayout="row" fxLayoutAlign="start center"
                fxLayoutGap="20px" (change)="onSelectionChange($event)">
                <mat-radio-button [attr.guide]="'lead-dynamic-form-chk-2-1' + '__' + sanitizeUrl(url)" value="individual">Individual</mat-radio-button>
                <mat-radio-button [attr.guide]="'lead-dynamic-form-chk-3-1' + '__' + sanitizeUrl(url)" value="business">Business</mat-radio-button>
            </mat-radio-group>

        </div>

        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Prefix</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-prefix-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Prefix"/>
            </mat-form-field>

            <mat-form-field fxFlex appearance="outline">
                <mat-label>First Name</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-name-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Name" required/>
                <mat-error *ngIf="form.get('Name')?.invalid && (form.get('Name')?.touched || form.get('Name')?.dirty)">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>


            <mat-form-field fxFlex appearance="outline">
                <mat-label>Middle Name</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-middlename-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="MiddleName"/>
            </mat-form-field>
        </div>

        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline" required>
                <mat-label>Last Name</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-lastname-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="LastName"/>
                <mat-error
                    *ngIf="form.get('LastName')?.invalid && (form.get('LastName')?.touched || form.get('LastName')?.dirty)">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <div class="time-picker-component">
                <mat-form-field appearance="outline" fxFlex="18" fxFlex.xs="25" fxLayoutGap="10px">
                  <mat-select formControlName="PhoneNumber" (selectionChange)="onSelectionChangeTwo($event)">
                    <mat-select-trigger>
                      {{ getCountryCode(form?.get('PhoneNumber')?.value || '') }}
                    </mat-select-trigger>
                    <mat-option>
                      <ngx-mat-select-search placeholderLabel="Search" [formControl]="searchControl"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let country of filteredCountries" [value]="country.id">
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <img [src]="country.flag" style="width: 20px; height: 15px; object-fit: cover;">
                        <span style="white-space: nowrap;">
                          {{country.dial_code}} {{country.name}}
                        </span>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              
                &#160;
              
                <div fxLayout="column" fxFlex fxLayoutGap="10px">
                  <mat-form-field fxFlex appearance="outline">
                    <mat-label>Mobile Number</mat-label>
                    <input [attr.guide]="'lead-dynamic-form-inp-4-1' + '__' + sanitizeUrl(url)" numbersOnly 
                           (input)="trimSpaces('endTimeHour'); 
                           form.get('endTimeHour').value && form.get('endTimeHour').value.length > 0 ? 
                           changeValue('endTimeHour', form.value.endTimeHour) : null" 
                           matInput type="tel" 
                           placeholder="Enter Number"
                           id="end_time_hour" 
                           formControlName="endTimeHour" 
                           (click)="preventMatSelectOpen($event)"
                           (keyup)="errmsg($event)" />
              
                    <!-- Required field error -->
                    <mat-error *ngIf="form.get('endTimeHour').hasError('required') && form.get('endTimeHour').touched">
                      This field is required
                    </mat-error>
              
                    <!-- Invalid number length error -->
                    <mat-error *ngIf="form.get('endTimeHour').hasError('customError')">
                      Please Enter a Valid Number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
        </div>

            <mat-form-field fxFlex appearance="outline">
                <mat-label>Email</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-email-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Email" required/>
                <mat-error
                    *ngIf="form.get('Email')?.invalid && (form.get('Email')?.touched || form.get('Email')?.dirty)">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Alt. Contact No</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-altcontactno-1' + '__' + sanitizeUrl(url)" numbersOnly [autocomplete]="'off'" trim="blur" matInput formControlName="AltContactNo"/>
            </mat-form-field>

            <mat-form-field fxFlex appearance="outline">
                <mat-label>Landline</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-landline-1' + '__' + sanitizeUrl(url)" numbersOnly [autocomplete]="'off'" trim="blur" matInput formControlName="Landline"/>
            </mat-form-field>

            <mat-form-field fxFlex appearance="outline">
                <mat-label>Age</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-age-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Age"/>
            </mat-form-field>
        </div>
        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


            <mat-form-field fxFlex appearance="outline">
                <mat-label>Date Of Birth</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-dateofbirth-1' + '__' + sanitizeUrl(url)" disabled [autocomplete]="'off'" formControlName="DateOfBirth" matInput
                    [matDatepicker]="startDate"/>
                <mat-datepicker-toggle matSuffix [for]="startDate">
                </mat-datepicker-toggle>
                <mat-datepicker disabled="false" #startDate></mat-datepicker>

            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Gender</mat-label>
                <mat-select formControlName="Gender">
                    <mat-option *ngFor="let item of gender" [value]="item.value">
                        {{item.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="isActive">
                    <mat-option *ngFor="let item of isActive" [value]="item.value">
                        {{item.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <calsoft-select-lead-form fxFlex="100" [frontEndLabel]="'Life Stage'" [frontEndLabelChange]="1"
                [attributeMap]="attributeMap" [group]="form" [attributeCode]="'LeadStatus'">
            </calsoft-select-lead-form>

            <calsoft-select-lead-form fxFlex="100" [attributeMap]="attributeMap" [group]="form"
                [attributeCode]="'LeadSource'">
            </calsoft-select-lead-form>

            <!-- <calsoft-select-lead-form fxFlex="100" [attributeMap]="attributeMap" [group]="form"
                [attributeCode]="'status'">
            </calsoft-select-lead-form> -->

            <calsoft-select-lead-form fxFlex="100" [attributeMap]="attributeMap" [group]="form"
                [attributeCode]="'LeadCategory'">
            </calsoft-select-lead-form>
        </div>



        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Deals Status</mat-label>
                <mat-select formControlName="DealStatus" [disableOptionCentering]="true" #singleSelect
                    autocomplete="off" required>
                    <mat-option>
                        <ngx-mat-select-search name="Deals Search" ngDefaultControl [formControl]="typeYFilterControl"
                            placeholderLabel="Deals Status Search" [preventHomeEndKeyPropagation]="true"
                            noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredDealsStatusTypeList; let i=index;" [value]="opt.statusId">
                        {{opt.statusName}}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="form.get('DealStatus')?.invalid && (form.get('DealStatus')?.touched || form.get('DealStatus')?.dirty)">
                    Please fill out this field.
                </mat-error>

            </mat-form-field>


            <mat-form-field fxFlex appearance="outline">
                <mat-label>Estimated Value</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-estimatedvalue-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="EstimatedValue"/>
            </mat-form-field>

            <!-- <mat-form-field fxFlex appearance="outline">
                <mat-label>Lead Category</mat-label>
                <mat-select formControlName="LeadCategory" [disableOptionCentering]="true" #singleSelect
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="LeadCategory Search" ngDefaultControl
                            [formControl]="typeYFilterControl" placeholderLabel="LeadCategory Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredDepartmentTypeList; let i=index;" [value]="opt.id">
                        {{opt.departmentName}}
                    </mat-option>
                </mat-select>
            </mat-form-field> -->

            <!-- <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
                <mat-label>{{field.frontendLabel}}</mat-label>
                <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
                  [disableOptionCentering]="true" [formControlName]="field.attributeCode" #singleSelect>
                  <mat-option>
                    <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="fieldFilterControl"
                      placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let item of fieldTypeList" [value]="item.optionId">
                    {{item.eavAttributeOptionValue[0]?.value}}</mat-option>
            
                </mat-select>
                <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                  <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
                </div>
              </mat-form-field> -->

            <mat-form-field appearance="outline" fxFlex>
                <mat-label>Priority</mat-label>
                <mat-select formControlName="Priority">
                    <mat-option *ngFor="let item of Priority" [value]="item.value">
                        {{item.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Department</mat-label>
                <mat-select formControlName="Department" [disableOptionCentering]="true" #singleSelect
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="Department Search" ngDefaultControl
                            [formControl]="typeYFilterControl" placeholderLabel="Department Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredDepartmentTypeList; let i=index;" [value]="opt.id">
                        {{opt.departmentName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex appearance="outline">
                <mat-label>Products Interested</mat-label>
                <mat-select formControlName="ProductIntrested" [disableOptionCentering]="true" #singleSelect
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="Products Search" ngDefaultControl
                            [formControl]="typeYFilterControl" placeholderLabel="Products Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredProductsTypeList; let i=index;" [value]="opt.name">
                        {{opt.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            <mat-form-field fxFlex appearance="outline" #step3Trigger>
                <mat-label>Assigned To</mat-label>
                <mat-select formControlName="Owner" [disableOptionCentering]="true" #singleSelect autocomplete="off"
                    required>
                    <mat-option>
                        <ngx-mat-select-search name="Owner Search" ngDefaultControl [formControl]="typeYFilterControl"
                            placeholderLabel="Owner Search" [preventHomeEndKeyPropagation]="true"
                            noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                        {{opt.email}}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="form.get('Owner')?.invalid && (form.get('Owner')?.touched || form.get('Owner')?.dirty)">
                    Please fill out this field.
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
            <mat-form-field *ngIf="selectedType1 == 'business' " fxFlex appearance="outline">
                <mat-label>GST</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-gst-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Gst"/>
            </mat-form-field>
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Lead Status Note</mat-label>
                <textarea [attr.guide]="'lead-dynamic-form-sel-leadstatusnote-1' + '__' + sanitizeUrl(url)" trim="blur" matInput matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
                    formControlName="LeadStatusNote"></textarea>

            </mat-form-field>

        </div>

        <div class='padding-10' fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
            <button [attr.guide]="'lead-dynamic-form-btn-5-1' + '__' + sanitizeUrl(url)" mat-button color="accent" (click)="moreInformation()" mat-raised-button>More Informations</button>
        </div>

        <mat-divider></mat-divider>
        <div class='padding-10' *ngIf="showTextField" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">

            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Country</mat-label>

                <mat-select [disableOptionCentering]="true" #singleSelect formControlName="Country" autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="Country Search" ngDefaultControl
                            [formControl]="countryFilterControl" placeholderLabel="Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredcountryTypeList" [value]="opt.countryName">
                        {{opt.countryName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            <mat-form-field fxFlex appearance="outline">
                <mat-label>State</mat-label>
                <mat-select formControlName="State">
                    <mat-option *ngFor="let item of State" [value]="item.viewValue">
                        {{item.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Address line 1</mat-label>
                <textarea [attr.guide]="'lead-dynamic-form-sel-addressline1-1' + '__' + sanitizeUrl(url)" trim="blur" matInput matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=3
                    formControlName="AddressLine1"></textarea>
            </mat-form-field>

            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Address line 2</mat-label>
                <textarea [attr.guide]="'lead-dynamic-form-sel-addressline2-1' + '__' + sanitizeUrl(url)" trim="blur" matInput matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=3
                    formControlName="Addressline2"></textarea>
            </mat-form-field>
        </div>

        <div class='padding-10' *ngIf="showTextField" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>District</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-district-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="District"/>
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Zip Code</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-zipcode-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="ZipCode"/>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <div class='padding-10' *ngIf="showTextField" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Tax Number</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-taxnumber-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="TaxNumber"/>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <div class='padding-10' *ngIf="showTextField" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Occupation</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-occupation-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="Occupation"/>
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Other Data</mat-label>
                <input [attr.guide]="'lead-dynamic-form-inp-otherdata-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" matInput formControlName="OtherData"/>
            </mat-form-field>
        </div>
    </form>
</div>




<div class="padding-10 btn" fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="end center">
    <button [attr.guide]="'lead-dynamic-form-btn-6-1' + '__' + sanitizeUrl(url)" [disabled]="text !='Save'" (click)="save()" mat-raised-button>
        {{text}}
        <mat-icon *ngIf="text !='Save' ">
            <mat-spinner color="primary" diameter="20">
            </mat-spinner>
        </mat-icon>
    </button>
</div>